// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './FishFinderBuilder.css';
import LandingPage from './components/LandingPage';
import Parent from './Parent';
import QuickScreenComparison from './components/QuickScreenComparison';
import Summary from './components/Summary';
import SharedLayout from './components/SharedLayout';
import FishFinderBuilder from './components/FishFinderBuilder';
import SelectionFlow from './components/SelectionFlow';
import AskQuestion from './components/AskQuestion';
import QuickBundles from './components/QuickBundles';
import SimpleLiveScopePlusLVS34 from './components/PriceComparison/SimpleLiveScopePlusLVS34';
import GarminEchomapUhd273sv from './components/PriceComparison/GarminEchomapUhd273sv';
import GarminEchomapUhd293sv from './components/PriceComparison/GarminEchomapUhd293sv';
import GarminEchomapUltra2106sv from './components/PriceComparison/GarminEchomapUltra2106sv';
import GarminEchomapUltra2126sv from './components/PriceComparison/GarminEchomapUltra2126sv';
import GarminGpsmap8610xsv from './components/PriceComparison/GarminGpsmap8610xsv';
import GarminGpsmap8612xsv from './components/PriceComparison/GarminGpsmap8612xsv';
import GarminGpsmap943xsv from './components/PriceComparison/GarminGpsmap943xsv';
import GarminGpsmap1243xsv from './components/PriceComparison/GarminGpsmap1243xsv';
import GarminGpsmap1042xsv from './components/PriceComparison/GarminGpsmap1042xsv';
import GarminGpsmap1242xsv from './components/PriceComparison/GarminGpsmap1242xsv';
import SimpleProductPage from './components/PriceComparison/SimpleProductPage';
import ProductPriceComparison from './components/PriceComparison/ProductPriceComparison';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route element={<SharedLayout />}>
            <Route path="/BuildMyFishFinder/*" element={<Parent />} />
            <Route path="/custom-builder" element={<FishFinderBuilder />} />
            <Route path="/quick-bundles" element={<QuickBundles />} />
            <Route path="/compare-screens" element={<QuickScreenComparison />} />
            <Route path="/summary" element={<Summary />} />
            <Route path="/select/:componentType" element={<SelectionFlow />} />
            <Route path="/ask-question" element={<AskQuestion />} />
            <Route path="/simple-products/livescope-plus-lvs34" element={<SimpleLiveScopePlusLVS34 />} />
            <Route path="/simple-products/echomap-73sv-uhd2" element={<GarminEchomapUhd273sv />} />
            <Route path="/simple-products/echomap-93sv-uhd2" element={<GarminEchomapUhd293sv />} />
            <Route path="/simple-products/echomap-ultra-2-106sv" element={<GarminEchomapUltra2106sv />} />
            <Route path="/simple-products/echomap-ultra-2-126sv" element={<GarminEchomapUltra2126sv />} />
            <Route path="/simple-products/gpsmap-8610xsv" element={<GarminGpsmap8610xsv />} />
            <Route path="/simple-products/gpsmap-8612xsv" element={<GarminGpsmap8612xsv />} />
            <Route path="/simple-products/gpsmap-943xsv" element={<GarminGpsmap943xsv />} />
            <Route path="/simple-products/gpsmap-1243xsv" element={<GarminGpsmap1243xsv />} />
            <Route path="/simple-products/gpsmap-1042xsv" element={<GarminGpsmap1042xsv />} />
            <Route path="/simple-products/gpsmap-1242xsv" element={<GarminGpsmap1242xsv />} />
            <Route path="/simple-products/:productId" element={<SimpleProductPage />} />
            <Route path="/products/:productId" element={<ProductPriceComparison />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
